/* eslint-disable @nx/enforce-module-boundaries */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OrbitFormClaimService } from './orbit-form-claim.service';
import { ClaimSteps } from '../statics/claim-steps.enum';
import { CONFIG } from '@domgen/dgx-fe-config';
import { AppConfig } from '@domgen/claims/feature-manage-my-repair';
import { map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LookupOptionsService {
  cachedResponses: Record<string, Record<string, any[]>> = {};
  claimData: any;

  constructor(
    private readonly http: HttpClient,
    private readonly claimFormService: OrbitFormClaimService,
    @Inject(CONFIG) private readonly config: AppConfig
  ) {}

  getLookupRequest(query: string) {
    switch (this.claimFormService.currentStep()) {
      case ClaimSteps.CaptureModelNumber:
        return {
          body: {
            searchTerm: query,
            dataType: 'ModelNumber',
            dataCategory: 'OEMAppliances',
            GUID: this.claimFormService.claimData()?.startTransaction.gUID,
          },
          url: `${this.config.brightClaimsAPI}/api/v1/orbit/GetData`,
        };
      default:
        return;
    }
  }

  lookupOptionsForStep(step: string, query: string) {
    if (query === '') return of([]);

    if (this.cachedResponses[step]) {
      if (this.cachedResponses[step][query]) {
        return of(this.cachedResponses[step][query]);
      }
    }

    const requestDetails = this.getLookupRequest(query);

    console.log(requestDetails.body);

    return this.http.post(requestDetails.url, requestDetails.body).pipe(
      map(
        (
          value:
            | {
                dataResult: {
                  dataIdentifier: string;
                  dataLabel: string;
                  productType: string;
                }[];
              }
            | any
        ) => {
          if (!this.cachedResponses[step]) {
            this.cachedResponses[step] = {};
          }
          const modelArray = value.dataResult;
          const optionsArray = modelArray.map((model) => ({
            title: model.dataLabel,
            value: model.dataIdentifier,
          }));

          return optionsArray;
        }
      )
    );
  }
}
